import { WarehouseManagement } from '@/api/index'

export function WarehouseTemplateDelete (data: any) {
  return WarehouseManagement.request({
    method: 'post',
    url: '/WarehouseTemplateDelete',
    data
  })
}
export function WarehouseSavePGSData (data: any) {
  return WarehouseManagement.request({
    method: 'post',
    url: '/SavePGSData',
    data
  })
}
